const states = [
	{
		value: 1,
		state: "Abia",
	},
	{
		value: 2,
		state: "Adamawa",
	},
	{
		value: 3,
		state: "Akwa Ibom",
	},
	{
		value: 4,
		state: "Anambra",
	},
	{
		value: 5,
		state: "Bauchi",
	},
	{
		value: 6,
		state: "Bayelsa",
	},
	{
		value: 7,
		state: "Benue",
	},
	{
		value: 8,
		state: "Borno",
	},
	{
		value: 9,
		state: "Cross River",
	},
	{
		value: 10,
		state: "Delta",
	},
	{
		value: 11,
		state: "Ebonyi",
	},
	{
		value: 12,
		state: "Edo",
	},
	{
		value: 13,
		state: "Ekiti",
	},
	{
		value: 14,
		state: "Enugu",
	},
	{
		value: 15,
		state: "Federal Capital Territory",
	},
	{
		value: 16,
		state: "Gombe",
	},
	{
		value: 17,
		state: "Imo",
	},
	{
		value: 18,
		state: "Jigawa",
	},
	{
		value: 19,
		state: "Kaduna",
	},
	{
		value: 20,
		state: "Kano",
	},
	{
		value: 21,
		state: "Katsina",
	},
	{
		value: 22,
		state: "Kebbi",
	},
	{
		value: 23,
		state: "Kogi",
	},
	{
		value: 24,
		state: "Kwara",
	},
	{
		value: 25,
		state: "Lagos",
	},
	{
		value: 26,
		state: "Nasarawa",
	},
	{
		value: 27,
		state: "Niger",
	},
	{
		value: 28,
		state: "Ogun",
	},
	{
		value: 29,
		state: "Ondo",
	},
	{
		value: 30,
		state: "Osun",
	},
	{
		value: 31,
		state: "Oyo",
	},
	{
		value: 32,
		state: "Plateau",
	},
	{
		value: 33,
		state: "Rivers",
	},
	{
		value: 34,
		state: "Sokoto",
	},
	{
		value: 35,
		state: "Taraba",
	},
	{
		value: 36,
		state: "Yobe",
	},
	{
		value: 37,
		state: "Zamfara",
	},
];

export default states;



// WEBPACK FOOTER //
// ./src/components/additions/checkout/states.js